import { Directive, effect, EventEmitter, input, Input, OnInit, Output } from "@angular/core";
import { FormControl, ValidatorFn } from "@angular/forms";

@Directive()
export abstract class CustomFormControl implements OnInit {

  public disabled = input<boolean | null>(null);

  @Input() extraValidators: ValidatorFn[] = [];

  @Output() inputReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

  public formInput!: FormControl;

  constructor() {
    effect(() => {
      this.applyDisabled();
    });
  }

  protected abstract createFormControl(): FormControl;

  public ngOnInit(): void {
    this.formInput = this.createFormControl();
    this.addExtraValidators();
    this.emitInputIsReady();
  }

  protected addExtraValidators() {
    this.formInput.addValidators(this.extraValidators);
  } 

  private emitInputIsReady() {
    this.emitInPromiseToPreventChangeDetection();
  }

  private emitInPromiseToPreventChangeDetection() {
    Promise.resolve().then(() => this.inputReady.emit(this.formInput));
  }

  private applyDisabled() {
    if(this.disabled() === null) {
      return;
    }
    if(this.disabled()) {
      this.formInput.disable();
    }
    else {
      this.formInput.enable();
    }
  }

}